import i18n from "i18next";

import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";

import {
  fallbackLanguage,
  supportedLanguages,
  translationResources,
} from "./locale-registry";

let initializationPromise: Promise<unknown> | null = null;

export function initializeI18n(): Promise<unknown> {
  if (initializationPromise) {
    return initializationPromise;
  }

  initializationPromise = i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: translationResources,

      fallbackLng: fallbackLanguage,

      supportedLngs: supportedLanguages,

      load: "languageOnly",

      nonExplicitSupportedLngs: true,

      ns: ["translation"],

      defaultNS: "translation",

      returnNull: false,

      interpolation: {
        escapeValue: false,
      },

      detection: {
        order: ["localStorage", "navigator"],

        caches: ["localStorage"],

        lookupLocalStorage: "tpm-language",
      },

      react: {
        useSuspense: false,
      },

      debug: import.meta.env.DEV && !import.meta.env.VITEST,
    });

  return initializationPromise;
}

export default i18n;
